"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var IconButtons_1 = require("atomicComponents/molecules/IconButtons/IconButtons");
var ProfileAvatar_1 = __importDefault(require("atomicComponents/molecules/Image/ProfileAvatar"));
var hooks_1 = require("containers/ConfirmationModal/hooks");
var DropdownMenu_1 = __importDefault(require("shared/components/DropdownMenu"));
var MenuItem_1 = __importDefault(require("shared/components/DropdownMenu/MenuItem"));
var Text_1 = __importDefault(require("shared/components/Text"));
var hooks_2 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var CommentEditor_1 = __importDefault(require("./CommentEditor"));
var CommentWrapper_1 = __importDefault(require("./CommentWrapper"));
var CommentView = function (_a) {
    var _b, _c;
    var comment = _a.comment;
    var myProfile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var _d = __read((0, react_1.useState)(false), 2), isEditing = _d[0], setIsEditing = _d[1];
    var _e = __read((0, hooks_2.useSubmitter)('comments', comment.id), 1), commentSubmitter = _e[0];
    var commentDate = (0, date_fns_1.formatRelative)(((_b = comment.createdAt) === null || _b === void 0 ? void 0 : _b.toDate()) || 0, new Date());
    var commentEditDate = (0, date_fns_1.formatRelative)(((_c = comment.updatedAt) === null || _c === void 0 ? void 0 : _c.toDate()) || 0, new Date());
    var _f = __read(react_1.default.useState(null), 2), anchorEl = _f[0], setAnchorEl = _f[1];
    var handleClick = function (event) { return setAnchorEl(anchorEl ? null : event.currentTarget); };
    var handleClose = function () { setAnchorEl(null); };
    var confirm = (0, hooks_1.useConfirm)();
    if (!(comment === null || comment === void 0 ? void 0 : comment.user)) {
        return null;
    }
    var handleDeleteComment = function () { return __awaiter(void 0, void 0, void 0, function () {
        var confirmed;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, confirm('Would you like to delete this comment?', '', 'red', 'Delete')];
                case 1:
                    confirmed = _a.sent();
                    if (!confirmed) return [3 /*break*/, 3];
                    return [4 /*yield*/, commentSubmitter('DELETE')];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    handleClose();
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(CommentWrapper_1.default, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pt: 0.25 }, { children: (0, jsx_runtime_1.jsx)(ProfileAvatar_1.default, { profile: comment.user }) })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ width: "100%" }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", justifyContent: "space-between", minHeight: 28 }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, ml: 1, mr: 0.5, fontWeight: "600" }, { children: (0, end2end_1.getDisplayName)(comment.user) })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption", sx: { lineHeight: 1.5 } }, { children: commentEditDate !== commentDate ? "edited ".concat(commentEditDate) : commentDate }))] })), (myProfile === null || myProfile === void 0 ? void 0 : myProfile.id) === comment.userId && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(IconButtons_1.ExpandMenuButton, { onClick: handleClick, sx: { visibility: 'hidden' } }), (0, jsx_runtime_1.jsxs)(DropdownMenu_1.default, __assign({ anchorEl: anchorEl, open: !!anchorEl, onClose: handleClose, sx: { maxWidth: 150 } }, { children: [(0, jsx_runtime_1.jsx)(MenuItem_1.default, __assign({ onClick: function () { setIsEditing(!isEditing); handleClose(); }, role: "button", autoFocus: true }, { children: "Edit" })), (0, jsx_runtime_1.jsx)(MenuItem_1.default, __assign({ onClick: handleDeleteComment, role: "button" }, { children: "Delete" }))] }))] }))] })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 2, sx: { lineHeight: 1.5, letterSpacing: '0.023em' } }, { children: (0, jsx_runtime_1.jsx)(CommentEditor_1.default, { serviceId: comment.serviceId, comment: comment, readOnly: !isEditing, closeEditMode: function () { return setIsEditing(false); } }) }))] }))] }));
};
exports.default = CommentView;
